import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { v4 as uuidV4 } from 'uuid'
import AddIcon from '@mui/icons-material/Add'
import { useIntl } from 'react-intl'
import { Button } from '../../components/Button'
import AdditionalRemindersListItem, {
	type Reminder,
} from './AdditionalRemindersListItem'
import { LayoutRow } from '../../components/layout'
import { AutoTaskRemindersFormFieldValues } from './AutoTaskRemindersForm'

export type AdditionalRemindersListProps = {
	reminders: Reminder[]
	onAddReminder: (reminder: Reminder) => void
	onRemoveReminder: (index: number) => void
}
const AdditionalRemindersList = ({
	reminders,
	onAddReminder,
	onRemoveReminder,
}: AdditionalRemindersListProps) => {
	const { formatMessage } = useIntl()
	const methods = useFormContext<AutoTaskRemindersFormFieldValues>()

	const handleAddReminder = () => {
		onAddReminder({
			id: uuidV4(),
			days: null,
			sequence: 'before',
		})
	}

	const isBetweenBeforeAfter = (index: number) => {
		const prevReminder = reminders[index - 1]
		const currentReminder = reminders[index]

		if (!prevReminder || !currentReminder) return false
		return (
			prevReminder.sequence === 'before' &&
			currentReminder.sequence === 'after'
		)
	}

	return (
		<>
			{reminders.length > 0 && (
				<LayoutRow className="flex flex-col w-full gap-4">
					{reminders.map((reminder, index) => (
						<div key={reminder.id}>
							{isBetweenBeforeAfter(index) && (
								<div className="relative text-center -mt-2 mb-2">
									<span className="absolute inset-0 flex items-center">
										<hr className="w-full border-gray-300" />
									</span>
									<span className="relative inline-block px-2 mb-1 text-gray-400 text-sm bg-white dark:bg-[#121212]">
										{formatMessage({
											id: 'auto_task_reminders.due_date',
										})}
									</span>
								</div>
							)}
							<Controller
								control={methods.control}
								name={`reminders.${index}`}
								rules={{ required: true }}
								defaultValue={reminder}
								render={({ field: { onChange, value } }) => (
									<AdditionalRemindersListItem
										key={value.id}
										data={value}
										onChange={onChange}
										onRemove={() => onRemoveReminder(index)}
										errors={
											methods.formState.errors.reminders?.[index]
										}
									/>
								)}
							/>
						</div>
					))}
				</LayoutRow>
			)}

			<LayoutRow>
				<Button
					text={formatMessage({
						id: 'auto_task_reminders.add_reminder',
					})}
					onClick={handleAddReminder}
					variant="text"
					startIcon={<AddIcon />}
				/>
			</LayoutRow>
		</>
	)
}
export default AdditionalRemindersList
